import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoLinkUploaderComponent } from './video-link-uploader.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconModule } from '../icon/icon.module';
import { InputModule } from '../input/input.module';

@NgModule({
  declarations: [
    VideoLinkUploaderComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconModule,
    InputModule
  ],
  exports: [
    VideoLinkUploaderComponent
  ]
})
export class VideoLinkUploaderModule { }
